<template>
	<div>
		<component :is="cmp" />
	</div>
</template>

<script>
import pc from './pc.vue'
import m from './m.vue'

export default {
	data() {
		return {
			cmp: null,
		}
	},
	mounted() {
		this.cmp = this.isPC ? pc : m
	},
}
</script>

<style lang="scss" scoped></style>
